import BookSegmentModal from "./book-segment-modal.component";

export default BookSegmentModal;
